// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"7e013d95","453":"3c4aa5a8","455":"f5aafe2e","977":"2fbe9f9d"}[chunkId] + ".chunk.js";
};